import { csvField } from './reportCsv'
import type { CompanyContact, ContactStatus } from '@/services/super-admin/contacts.service'

const STATUS_LABEL: Record<ContactStatus, string> = {
  novo: 'Novo',
  em_contato: 'Em contato',
  convertido: 'Convertido',
  descartado: 'Descartado',
}

/**
 * Neutraliza fórmula de planilha.
 *
 * Diferente dos relatórios, aqui o conteúdo vem de um formulário público
 * e anônimo. Um campo começando com `=`, `+`, `-` ou `@` é executado como
 * fórmula quando o arquivo abre no Excel do time — prefixar com aspas
 * simples faz o Excel tratar como texto.
 */
function safeCell(value: string | null | undefined): string {
  const s = value ?? ''
  return /^[=+\-@]/.test(s) ? `'${s}` : s
}

function formatDateTime(iso: string): string {
  const d = new Date(iso)
  return isNaN(d.getTime()) ? '' : d.toLocaleString('pt-BR')
}

/** Gera o CSV dos contatos comerciais (separador `;`, padrão pt-BR do Excel). */
export function buildContactsCsv(contacts: CompanyContact[]): string {
  const header = ['Empresa', 'Nome', 'E-mail', 'Telefone', 'Status', 'Recebido em', 'Anotações']
  const lines = [header.join(';')]

  for (const c of contacts) {
    lines.push(
      [
        csvField(safeCell(c.company)),
        csvField(safeCell(c.name)),
        csvField(safeCell(c.email)),
        csvField(safeCell(c.phone)),
        csvField(STATUS_LABEL[c.status] ?? c.status),
        csvField(formatDateTime(c.createdAt)),
        csvField(safeCell(c.notes)),
      ].join(';')
    )
  }

  return lines.join('\n')
}

/** Dispara o download do CSV (BOM pra o Excel abrir os acentos certos). */
export function downloadContactsCsv(contacts: CompanyContact[]): void {
  const BOM = String.fromCharCode(0xfeff)
  const blob = new Blob([BOM + buildContactsCsv(contacts)], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'contatos-comerciais.csv'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
